import classNames from 'classnames'
import { Notification } from '@lounge-fe/ui-kit'
import { ProductNoticeProps } from './types'

export const ProductNotice = ({
  className,
  notice,
  ...props
}: ProductNoticeProps) => {
  return (
    <Notification
      className={classNames(
        'border border-primary-default leading-md',
        className,
      )}
      {...props}
    >
      <span dangerouslySetInnerHTML={{ __html: notice }} />
    </Notification>
  )
}
